export type AutoTransactionExecResult =
  | 'failed'
  | 'pending'
  | 'running'
  | 'skipped'
  | 'success'
  | 'throttled'

export type AutoTransactionExecResultRequestValue =
  | 'Failure'
  | 'Pending'
  | 'Running'
  | 'Skipped'
  | 'Success'
  | 'Throttled'

const execResultAliasMap: Record<string, AutoTransactionExecResult> = {
  failed: 'failed',
  failure: 'failed',
  pending: 'pending',
  running: 'running',
  skipped: 'skipped',
  success: 'success',
  throttled: 'throttled',
}

export const autoTransactionExecResultRequestValueMap: Record<
  AutoTransactionExecResult,
  AutoTransactionExecResultRequestValue
> = {
  failed: 'Failure',
  pending: 'Pending',
  running: 'Running',
  skipped: 'Skipped',
  success: 'Success',
  throttled: 'Throttled',
}

export function normalizeAutoTransactionExecResult(
  value: string | undefined,
): AutoTransactionExecResult | undefined {
  if (!value) return undefined

  return execResultAliasMap[value.toLowerCase()]
}
